import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function SessionGuard() {
  const { user, setUser, logout } = useAuth();
  const lastActivity = useRef(Date.now());
  const idleMin = useRef(15);
  const [warn, setWarn] = useState(false);
  const [count, setCount] = useState(60);
  const [pwOpen, setPwOpen] = useState(false);
  const [cur, setCur] = useState(""); const [np, setNp] = useState(""); const [np2, setNp2] = useState(""); const [saving, setSaving] = useState(false);

  useEffect(() => { if (user && user.must_change_password) setPwOpen(true); }, [user]);

  useEffect(() => {
    if (!user) return;
    api.get("/settings/inattivita").then(r => { idleMin.current = r.data.inactivity_min || 15; }).catch(() => {});
    const hb = () => api.post("/heartbeat").catch(() => {});
    hb();
    const t = setInterval(hb, 60000);
    return () => clearInterval(t);
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const bump = () => { lastActivity.current = Date.now(); if (warn) setWarn(false); };
    const evts = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    evts.forEach(e => window.addEventListener(e, bump, { passive: true }));
    const check = setInterval(() => {
      const bbbUntil = Number(localStorage.getItem("iste_bbb_open_until") || 0);
      if (Date.now() < bbbUntil) { lastActivity.current = Date.now(); return; }
      const idleMs = Date.now() - lastActivity.current;
      if (!warn && idleMs >= idleMin.current * 60000) { setWarn(true); setCount(60); }
    }, 15000);
    return () => { evts.forEach(e => window.removeEventListener(e, bump)); clearInterval(check); };
  }, [user, warn]);

  useEffect(() => {
    if (!warn) return;
    const t = setInterval(() => {
      setCount(c => { if (c <= 1) { clearInterval(t); logout(); return 0; } return c - 1; });
    }, 1000);
    return () => clearInterval(t);
  }, [warn, logout]);

  const changePw = async () => {
    if (np.length < 8) { toast.error("La nuova password deve avere almeno 8 caratteri"); return; }
    if (np !== np2) { toast.error("Le password non coincidono"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: np });
      const me = await api.get("/auth/me"); setUser(me.data);
      toast.success("Password aggiornata"); setPwOpen(false); setCur(""); setNp(""); setNp2("");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore cambio password"); }
    finally { setSaving(false); }
  };

  if (!user) return null;
  return (
    <>
      <Dialog open={warn} onOpenChange={() => {}}>
        <DialogContent data-testid="idle-warning-dialog">
          <DialogHeader><DialogTitle>Sei ancora qui?</DialogTitle><DialogDescription>Per inattività verrai disconnesso tra {count} secondi.</DialogDescription></DialogHeader>
          <DialogFooter><Button onClick={() => { lastActivity.current = Date.now(); setWarn(false); }} className="bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="idle-stay-btn">Resta connesso</Button></DialogFooter>
        </DialogContent>
      </Dialog>
      <Dialog open={pwOpen} onOpenChange={() => {}}>
        <DialogContent data-testid="force-pwd-dialog">
          <DialogHeader><DialogTitle>Cambia la password</DialogTitle><DialogDescription>Al primo accesso devi impostare una nuova password personale.</DialogDescription></DialogHeader>
          <div className="grid gap-3">
            <div><Label>Password attuale</Label><Input type="password" value={cur} onChange={e => setCur(e.target.value)} data-testid="force-pwd-current"/></div>
            <div><Label>Nuova password</Label><Input type="password" value={np} onChange={e => setNp(e.target.value)} data-testid="force-pwd-new"/></div>
            <div><Label>Conferma nuova password</Label><Input type="password" value={np2} onChange={e => setNp2(e.target.value)} data-testid="force-pwd-new2"/></div>
          </div>
          <DialogFooter><Button onClick={changePw} disabled={saving} className="bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="force-pwd-save">{saving ? "Salvataggio..." : "Imposta password"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
